import React, { useState, useRef, useCallback, useEffect } from 'react'
import './ProjectsSection.css'

const PROJECTS = [
  {
    id: 1,
    title: 'Site Plaisir Permis',
    subtitle: 'Full-Stack + IA Chatbot',
    category: 'web',
    year: '2026',
    status: 'live',
    description: 'Site complet en full-stack pour une auto-école : gestion de flotte, base de données clients, et un chatbot IA spécialisé ANTS/Permis de conduire.',
    tags: ['React', 'Full-Stack', 'IA', 'PostgreSQL', 'OVH'],
    color: '#00ff88',
    accentColor: '#00aaff',
    metrics: [{ label: 'IA Chatbot', value: 'ANTS' }, { label: 'DB Clients', value: 'SQL' }, { label: 'Flotte', value: 'Géré' }],
    featured: true,
    liveUrl: 'https://plaisirpermis.fr',
    githubUrl: 'https://github.com/QuentinOTT/plaisir-permis',
  },
  {
    id: 2,
    title: 'App de Facturation',
    subtitle: 'Logiciel Python Desktop',
    category: 'app',
    year: '2025',
    status: 'live',
    description: 'Application desktop de facturation complète : création de devis, gestion de factures, suivi des paiements et reporting analytique.',
    tags: ['Python', 'Tkinter', 'SQLite', 'Reportlab'],
    color: '#a78bfa',
    accentColor: '#818cf8',
    metrics: [{ label: 'Devis', value: '✓' }, { label: 'Factures', value: '✓' }, { label: 'Reporting', value: '✓' }],
    featured: true,
    liveUrl: null,
    githubUrl: 'https://github.com/QuentinOTT/app-facturation',
  },
  {
    id: 3,
    title: 'Speed Nation',
    subtitle: 'Réseau social automobile',
    category: 'web',
    year: '2024',
    status: 'live',
    description: 'Réseau social dédié aux passionnés d\'automobile avec messagerie instantanée, partage de photos et organisation de rassemblements.',
    tags: ['Python', 'Supabase', 'SQL', 'HTML/CSS/JS','Expo'],
    color: '#f59e0b',
    accentColor: '#ef4444',
    metrics: [{ label: 'Chat', value: 'Live' }, { label: 'Events', value: '✓' }, { label: 'Profils', value: '✓' }],
    featured: false,
    liveUrl: null,
    githubUrl: 'https://github.com/QuentinOTT/speed-nation',
  },
  {
    id: 4,
    title: 'Sites Freelance',
    subtitle: 'Restaurant, Taxi, Commerce',
    category: 'web',
    year: '2024',
    status: 'live',
    description: 'Multiples sites professionnels pour restaurants, auto-écoles, taxis et associations. Frontend responsive avec SGBDR complet et hébergement géré.',
    tags: ['Vue.js', 'React', 'MySQL', 'OVH', 'Hostinger'],
    color: '#06b6d4',
    accentColor: '#0ea5e9',
    metrics: [{ label: 'Sites', value: '5+' }, { label: 'Héberg.', value: 'Géré' }, { label: 'DB', value: 'SQL' }],
    featured: false,
    liveUrl: null,
    githubUrl: 'https://github.com/QuentinOTT/sites-freelance',
  },
  {
    id: 5,
    title: 'Optimisation Stellantis',
    subtitle: 'Automatisation de process',
    category: 'data',
    year: '2024',
    status: 'live',
    description: 'Simplification des processus de commande de matériel informatique pour Stellantis. Workflow d\'automatisation et documentation complète.',
    tags: ['Visio office', 'Automatisation', 'Excel', 'Documentation'],
    color: '#10b981',
    accentColor: '#34d399',
    metrics: [{ label: 'Process', value: 'Optim.' }, { label: 'Scripts', value: 'Python' }, { label: 'Docs', value: '✓' }],
    featured: false,
    liveUrl: null,
    githubUrl: 'https://github.com/QuentinOTT/optimisation-stellantis',
  },
  {
    id: 6,
    title: 'Application Gestion Flotte Automobile',
    subtitle: 'Application Expo React Native',
    category: 'app',
    year: '2025',
    status: 'live',
    description: 'Application mobile de gestion de flotte automobile : suivi des véhicules, entretiens, assurances et coûts.',
    tags: ['React Native', 'Expo', 'SQLite'],
    color: '#ff6b6b',
    accentColor: '#ffd93d',
    metrics: [{ label: 'Base de données', value: 'SQL' }, { label: 'Physics', value: '✓' }, { label: 'Mobile', value: '✓' }],
    featured: true,
    liveUrl: null,
    githubUrl: 'https://github.com/QuentinOTT/gestion-flotte',
  },
  {
    id: 7,
    title: 'Site Escadron Air',
    subtitle: 'Site Vitrine Armée de l\'Air',
    category: 'web',
    year: '2025',
    status: 'live',
    description: 'Création d\'un site vitrine pour un escadron de l\'armée de l\'air qui est en veille. Site moderne et responsive présentant les activités et l\'histoire de l\'escadron.',
    tags: ['React Native', 'HTML', 'JavaScript'],
    color: '#1e40af',
    accentColor: '#3b82f6',
    metrics: [{ label: 'Design', value: 'Moderne' }, { label: 'Mobile', value: '✓' }, { label: 'Responsive', value: '✓' }],
    featured: false,
    liveUrl: null,
    githubUrl: 'https://github.com/QuentinOTT/site-escadron-air',
  },
]

const CATEGORIES = [
  { id: 'all', label: 'Tous', icon: '⬡' },
  { id: 'web', label: 'Web', icon: '◈' },
  { id: 'app', label: 'App', icon: '◉' },
  { id: 'data', label: 'Data', icon: '◎' },
  { id: '3d', label: '3D', icon: '✦' },
]

const STATUS_CONFIG = {
  live: { label: 'Live', color: '#00ff88' },
  'open-source': { label: 'Open Source', color: '#00aaff' },
}

function useReveal(threshold = 0.1) {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setVisible(true); obs.disconnect() }
    }, { threshold })
    if (ref.current) obs.observe(ref.current)
    return () => obs.disconnect()
  }, [threshold])
  return [ref, visible]
}

function useCursorGlow(ref) {
  useEffect(() => {
    const el = ref.current
    if (!el) return
    const onMove = (e) => {
      const rect = el.getBoundingClientRect()
      el.style.setProperty('--mx', `${((e.clientX - rect.left) / rect.width) * 100}%`)
      el.style.setProperty('--my', `${((e.clientY - rect.top) / rect.height) * 100}%`)
    }
    el.addEventListener('mousemove', onMove)
    return () => el.removeEventListener('mousemove', onMove)
  }, [ref])
}

function ProjectCard({ project, index, onClick }) {
  const cardRef = useRef(null)
  const [tilt, setTilt] = useState({ x: 0, y: 0 })
  const [hovered, setHovered] = useState(false)
  const [revealRef, visible] = useReveal()
  useCursorGlow(cardRef)

  const handleMouseMove = useCallback((e) => {
    const rect = cardRef.current.getBoundingClientRect()
    const cx = rect.left + rect.width / 2
    const cy = rect.top + rect.height / 2
    setTilt({ x: ((e.clientY - cy) / rect.height) * 10, y: -((e.clientX - cx) / rect.width) * 10 })
  }, [])

  const status = STATUS_CONFIG[project.status] || STATUS_CONFIG.live

  return (
    <div
      ref={revealRef}
      className={`proj-card-wrapper ${visible ? 'revealed' : ''} ${project.featured ? 'featured' : ''}`}
      style={{ '--delay': `${index * 80}ms` }}
    >
      <div
        ref={cardRef}
        className={`proj-card glass-card ${hovered ? 'hovered' : ''}`}
        style={{
          '--card-color': project.color,
          '--card-accent': project.accentColor,
          transform: hovered
            ? `perspective(1000px) rotateX(${tilt.x}deg) rotateY(${tilt.y}deg) translateZ(8px)`
            : 'perspective(1000px) rotateX(0deg) rotateY(0deg) translateZ(0px)',
        }}
        onMouseMove={handleMouseMove}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => { setTilt({ x: 0, y: 0 }); setHovered(false) }}
        onClick={() => onClick(project)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && onClick(project)}
        aria-label={`Voir le projet ${project.title}`}
      >
        <div className="proj-card-glow" />

        <div className="proj-card-top">
          <span className="proj-year">{project.year}</span>
          <span className="proj-status" style={{ '--status-color': status.color }}>
            <span className="proj-status-dot" />
            {status.label}
          </span>
        </div>

        <div className="proj-visual">
          <div className="proj-icon-ring">
            <span className="proj-icon">
              {project.category === 'web' && '◈'}
              {project.category === 'app' && '◉'}
              {project.category === 'data' && '◎'}
              {project.category === '3d' && '✦'}
            </span>
          </div>
          {project.featured && <span className="proj-featured">Featured</span>}
        </div>

        <div className="proj-content">
          <p className="proj-subtitle">{project.subtitle}</p>
          <h3 className="proj-title">{project.title}</h3>
          <p className="proj-desc">{project.description}</p>
        </div>

        <div className="proj-tags">
          {project.tags.slice(0, 3).map(t => <span key={t} className="proj-tag">{t}</span>)}
          {project.tags.length > 3 && <span className="proj-tag">+{project.tags.length - 3}</span>}
        </div>

        <div className="proj-metrics">
          {project.metrics.map(m => (
            <div key={m.label} className="proj-metric">
              <span className="proj-metric-val">{m.value}</span>
              <span className="proj-metric-label">{m.label}</span>
            </div>
          ))}
        </div>

        <div className="proj-cta">
          <span>Voir les détails</span>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </div>
        <div className="proj-border-line" />
      </div>
    </div>
  )
}

function ProjectModal({ project, onClose }) {
  const overlayRef = useRef(null)
  const [mounted, setMounted] = useState(false)
  const [currentImageIndex, setCurrentImageIndex] = useState(0)

  // Générer la liste des images pour le projet
  const projectImages = React.useMemo(() => {
    const imageFolder = `/projects/${project.id === 1 ? 'site-plaisir-permis' : 
                                   project.id === 2 ? 'app-facturation' :
                                   project.id === 3 ? 'speed-nation' :
                                   project.id === 4 ? 'sites-freelance' :
                                   project.id === 5 ? 'optimisation-stellantis' :
                                   project.id === 7 ? 'site-escadron-air' :
                                   'gestion-flotte'}`
    
    // Générer une liste d'images selon le projet
    const images = []
    if (project.id === 1) {
      // Site Plaisir Permis - fichiers .png avec préfixe
      for (let i = 1; i <= 7; i++) {
        images.push(`${imageFolder}/plaisir-permis-${i}.png`)
      }
    } else if (project.id === 2) {
      // App de Facturation - fichiers .png avec préfixe
      for (let i = 1; i <= 7; i++) {
        images.push(`${imageFolder}/app-facturation${i}.png`)
      }
    } else if (project.id === 3) {
      // Speed Nation - fichiers .PNG avec préfixe (majuscule) - format mobile
      for (let i = 1; i <= 5; i++) {
        images.push(`${imageFolder}/speed-nation${i}.PNG`)
      }
    } else if (project.id === 7) {
      // Site Escadron Air - fichiers .png avec préfixe
      for (let i = 1; i <= 7; i++) {
        images.push(`${imageFolder}/site-escadron-air${i}.png`)
      }
    } else if (project.id === 6) {
      // Gestion Flotte - fichiers .png avec préfixe - format mobile
      for (let i = 1; i <= 10; i++) {
        images.push(`${imageFolder}/gestion-flotte${i}.png`)
      }
    } else {
      // Autres projets - fichiers .png standards
      for (let i = 1; i <= 5; i++) {
        images.push(`${imageFolder}/${i}.png`)
      }
    }
    return images
  }, [project.id])

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % projectImages.length)
  }

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + projectImages.length) % projectImages.length)
  }

  const handleClose = useCallback(() => { setMounted(false); setTimeout(onClose, 300) }, [onClose])

  useEffect(() => {
    requestAnimationFrame(() => setMounted(true))
    document.body.style.overflow = 'hidden'
    const onKey = (e) => e.key === 'Escape' && handleClose()
    window.addEventListener('keydown', onKey)
    return () => { document.body.style.overflow = ''; window.removeEventListener('keydown', onKey) }
  }, [handleClose])

  return (
    <div
      ref={overlayRef}
      className={`proj-modal-overlay ${mounted ? 'visible' : ''}`}
      onClick={(e) => e.target === overlayRef.current && handleClose()}
      role="dialog"
      aria-modal="true"
    >
      <div className="proj-modal" style={{ '--card-color': project.color, '--card-accent': project.accentColor }}>
        <button className="proj-modal-close" onClick={handleClose} aria-label="Fermer">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M3 3l12 12M15 3L3 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
          </svg>
        </button>
        <div className="proj-modal-scroll">
          <div className="proj-modal-header">
            <div className="proj-modal-icon">
              {project.category === 'web' && '◈'}
              {project.category === 'app' && '◉'}
              {project.category === 'data' && '◎'}
              {project.category === '3d' && '✦'}
            </div>
            <div>
              <p className="proj-modal-subtitle">{project.subtitle}</p>
              <h2 className="proj-modal-title">{project.title}</h2>
            </div>
          </div>
          <div className="proj-modal-metrics">
            {project.metrics.map(m => (
              <div key={m.label} className="proj-modal-metric">
                <span className="proj-modal-metric-val">{m.value}</span>
                <span className="proj-modal-metric-label">{m.label}</span>
              </div>
            ))}
          </div>
          <p className="proj-modal-desc">{project.description}</p>
          <div className="proj-modal-tags">
            {project.tags.map(t => <span key={t} className="proj-modal-tag">{t}</span>)}
          </div>
          
          {/* Liens du projet */}
          <div className="proj-modal-links">
            {project.liveUrl && (
              <a href={project.liveUrl} target="_blank" rel="noopener noreferrer" className="proj-modal-link">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z"/>
                  <path d="M11 7H9V5c0-.6-.4-1-1-1s-1 .4-1 1v2H5c-.6 0-1 .4-1 1s.4 1 1 1h2v2c0 .6.4 1 1 1s1-.4 1-1V9h2c.6 0 1-.4 1-1s-.4-1-1-1z"/>
                </svg>
                Voir le site
              </a>
            )}
            {project.githubUrl && (
              <a href={project.githubUrl} target="_blank" rel="noopener noreferrer" className="proj-modal-link">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                  <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/>
                </svg>
                Voir le code
              </a>
            )}
          </div>
          
          {/* Carousel d'images */}
          <div className="proj-modal-carousel">
            <div className={`carousel-container ${(project.category === 'app' || (project.id === 3 && project.category === 'web')) ? 'mobile-format' : ''}`}>
              <div className={`carousel-images ${(project.category === 'app' || (project.id === 3 && project.category === 'web')) ? 'mobile-format' : ''}`}>
                {projectImages.map((image, index) => (
                  <img
                    key={index}
                    src={image}
                    alt={`${project.title} - ${index + 1}`}
                    className={`carousel-image ${index === currentImageIndex ? 'active' : ''}`}
                    onError={(e) => {
                      e.target.style.display = 'none'
                    }}
                  />
                ))}
              </div>
              {projectImages.length > 1 && (
                <>
                  <button className="carousel-btn carousel-btn-prev" onClick={prevImage}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <button className="carousel-btn carousel-btn-next" onClick={nextImage}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                      <path d="M7.5 5L12.5 10L7.5 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </button>
                  <div className="carousel-dots">
                    {projectImages.map((_, index) => (
                      <button
                        key={index}
                        className={`carousel-dot ${index === currentImageIndex ? 'active' : ''}`}
                        onClick={() => setCurrentImageIndex(index)}
                      />
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function ProjectsSection() {
  const [sectionRef, visible] = useReveal()
  const [activeFilter, setActiveFilter] = useState('all')
  const [selected, setSelected] = useState(null)
  const filterRef = useRef(null)
  const indicatorRef = useRef(null)

  useEffect(() => {
    if (!filterRef.current || !indicatorRef.current) return
    const btn = filterRef.current.querySelector(`[data-cat="${activeFilter}"]`)
    if (!btn) return
    const barRect = filterRef.current.getBoundingClientRect()
    const btnRect = btn.getBoundingClientRect()
    indicatorRef.current.style.left = `${btnRect.left - barRect.left}px`
    indicatorRef.current.style.width = `${btnRect.width}px`
  }, [activeFilter])

  const filtered = PROJECTS.filter(p => activeFilter === 'all' || p.category === activeFilter)

  return (
    <section id="projects" className="section projects-section" ref={sectionRef} aria-label="Projets">
      <div className={`section-inner ${visible ? 'visible' : ''}`}>
        <div className="section-label"><span>03</span> Projets</div>
        <h2 className="section-title">
          Mes <span className="gradient-text">Réalisations</span>
        </h2>
        <p className="section-desc">
          Sites web, applications desktop, outils data et expériences 3D — des projets concrets, déployés et utilisés.
        </p>

        {/* Filter */}
        <div className="proj-filters" ref={filterRef} role="tablist">
          <div className="proj-filter-indicator" ref={indicatorRef} />
          {CATEGORIES.map(cat => (
            <button
              key={cat.id}
              data-cat={cat.id}
              className={`proj-filter-btn ${activeFilter === cat.id ? 'active' : ''}`}
              onClick={() => setActiveFilter(cat.id)}
              role="tab"
              aria-selected={activeFilter === cat.id}
            >
              <span>{cat.icon}</span>
              <span>{cat.label}</span>
            </button>
          ))}
        </div>

        {/* Grid */}
        <div className="proj-grid">
          {filtered.map((project, i) => (
            <ProjectCard key={project.id} project={project} index={i} onClick={setSelected} />
          ))}
        </div>
      </div>
      {selected && <ProjectModal project={selected} onClose={() => setSelected(null)} />}
    </section>
  )
}
